export const sortByField = (array = [], field = '') => array.sort((a, b) => a[field] !== b[field] ? a[field] < b[field] ? -1 : 1 : 0);

export const sortObject = obj => {
  return Object.keys(obj).sort().reduce((result, key) => {
    result[key] = obj[key];
    return result;
  }, {});
};
